import {useCallback, useMemo} from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {blocklist} from '~/GalleryPB/components/Template/components/QuickView/constants';
import {selectTemplates} from '~/GalleryPB/reducers/galleryData';
import type {Template} from '~/GalleryPB/types/template';
import {useIsMediumAndUp} from '~library/hooks/useMatchQuery';

export const useTemplateHelpers = () => {
  const templates = useSelector(selectTemplates, shallowEqual);
  const isMediumAndUp = useIsMediumAndUp();

  const allTemplates = useMemo(
    () => [...templates.free, ...templates.premium],
    [templates.free, templates.premium]
  );

  const findTemplateById = useCallback(
    (templateId: string) => {
      if (!templateId) return undefined;
      return allTemplates.find((t) => t?.templateId === templateId);
    },
    [allTemplates]
  );

  const checkIfQuickViewEnabledForTemplate = useCallback((template: Template) => {
    if (!template?.categories) return false;
    return !blocklist.some((cat) => template.categories.includes(cat));
  }, []);

  const checkIfQuickViewEnabled = useCallback(
    (template: Template | string) => {
      if (!isMediumAndUp || !template) return false;

      const templateObj = typeof template === 'string' ? findTemplateById(template) : template;

      return templateObj && checkIfQuickViewEnabledForTemplate(templateObj);
    },
    [isMediumAndUp, findTemplateById, checkIfQuickViewEnabledForTemplate]
  );

  return {
    checkIfQuickViewEnabled,
    findTemplateById,
  };
};
